import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

function DownlineTreeNode({ node, level = 0 }) {
  const [expanded, setExpanded] = useState(level === 0);

  if (!node) return null;

  const hasReports = node.direct_reports && node.direct_reports.length > 0;
  const stats = node.assignment_stats || { total: 0, completed: 0, in_progress: 0, overdue: 0 };

  return (
    <div style={{ marginLeft: level > 0 ? '2rem' : 0 }}>
      <div
        style={{
          padding: '1rem',
          backgroundColor: 'var(--white)',
          border: '1px solid var(--gray-300)',
          borderRadius: '8px',
          marginBottom: '0.75rem',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {hasReports && (
            <button
              onClick={() => setExpanded(!expanded)}
              style={{
                width: '1.5rem',
                height: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid var(--gray-400)',
                borderRadius: '4px',
                backgroundColor: 'var(--white)',
                cursor: 'pointer',
                fontSize: '0.75rem',
              }}
              data-testid={`toggle-${node.id}`}
            >
              {expanded ? '−' : '+'}
            </button>
          )}
          {!hasReports && <div style={{ width: '1.5rem' }} />}
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: '600', fontSize: '1rem' }}>{node.name}</div>
            <div style={{ fontSize: '0.75rem', color: 'var(--gray-600)' }}>
              {node.role.replace('_', ' ')} • {node.email}
            </div>
          </div>
          <div style={{ display: 'flex', gap: '1rem', fontSize: '0.875rem' }}>
            <div>
              <span style={{ fontWeight: '600', color: 'var(--success-600)' }}>{stats.completed}</span>
              <span style={{ color: 'var(--gray-600)' }}> completed</span>
            </div>
            <div>
              <span style={{ fontWeight: '600', color: 'var(--warning-600)' }}>{stats.in_progress}</span>
              <span style={{ color: 'var(--gray-600)' }}> active</span>
            </div>
            {stats.overdue > 0 && (
              <div>
                <span style={{ fontWeight: '600', color: 'var(--danger-600)' }}>{stats.overdue}</span>
                <span style={{ color: 'var(--gray-600)' }}> overdue</span>
              </div>
            )}
          </div>
        </div>
      </div>
      {expanded && hasReports && (
        <div>
          {node.direct_reports.map((report) => (
            <DownlineTreeNode key={report.id} node={report} level={level + 1} />
          ))}
        </div>
      )}
    </div>
  );
}

function DownlineView() {
  const [treeData, setTreeData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTree();
  }, []);

  const loadTree = async () => {
    try {
      const data = await api.get('/reporting/team-tree');
      setTreeData(data);
    } catch (err) {
      console.error('Failed to load tree:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading-screen"><div className="spinner"></div></div>;
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Downline View</h1>
        <p className="page-subtitle">Hierarchical view of your team and their assignments</p>
      </div>

      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Team Hierarchy</h2>
        </div>
        <div style={{ padding: '1.5rem' }}>
          {treeData ? (
            <DownlineTreeNode node={treeData} />
          ) : (
            <div className="empty-state">
              <div className="empty-state-icon">🌳</div>
              <h3 className="empty-state-title">No Team Data</h3>
              <p className="empty-state-description">Unable to load team hierarchy</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DownlineView;
